import Seo from "../components/Seo";
import { site } from "../config/site";

export default function Impressum() {
  return (
    <>
      <Seo title="Impressum" path="/impressum" />

      {/* Page-Header */}
      <section className="bg-primary text-white">
        <div className="mx-auto max-w-6xl px-4 py-16">
          <h1 className="text-5xl md:text-6xl font-extrabold uppercase">Impressum</h1>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 space-y-6 text-dark/80 text-sm leading-relaxed">
        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Herausgeber</h2>
          <p>{site.name}</p>
          <p>{site.contact.address}</p>
        </div>
        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Kontakt</h2>
          <p>Telefon: <a href={`tel:${site.contact.phone}`} className="text-primary hover:underline">{site.contact.phone}</a></p>
          <p>E-Mail: <a href={`mailto:${site.contact.email}`} className="text-primary hover:underline">{site.contact.email}</a></p>
        </div>
        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Verantwortlich für den Inhalt</h2>
          <p>Urs Ottiger, Seeparkstrasse 2, 6207 Nottwil</p>
        </div>
        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Haftungsausschluss</h2>
          <p>
            Die Inhalte dieser Website wurden sorgfältig zusammengestellt. Für die Richtigkeit, Vollständigkeit und
            Aktualität der Inhalte übernimmt der Herausgeber keine Gewähr. Externe Links werden regelmässig geprüft;
            für deren Inhalt sind die jeweiligen Betreiber verantwortlich.
          </p>
        </div>
        <div>
          <h2 className="font-bold text-dark uppercase tracking-wide mb-2">Urheberrecht</h2>
          <p>
            Alle Inhalte dieser Website (Texte, Bilder, Grafiken) sind urheberrechtlich geschützt und dürfen ohne
            schriftliche Genehmigung des Herausgebers nicht vervielfältigt oder verbreitet werden.
          </p>
        </div>
      </section>
    </>
  );
}
